import { gql, TypedDocumentNode } from '@common/hooks';
import { RoleType } from '@clinician-profile/graphql/types';

export const RolesQuery: TypedDocumentNode<RolesResponse, RolesVariables> = gql`
  query Roles($ids: [String!]) {
    roles(ids: $ids) {
      id
      name
      abbreviation
    }
  }
`;

export type RolesResponse = {
  roles: RoleType[];
};

export type RolesVariables = {
  ids?: string[];
};
